import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import {
  componentKey,
  getInventoriesListData,
  setCloseAddNotesDialog,
  setCloseDeleteInventoryDialog,
  setCloseRequestInventoryDialog,
  setCloseSendBulkDialog,
  setGroupedNotesData,
  setInventoryData,
} from "./InventorySlice";
import InventoryService from "../../services/InventoryService";

export const {
  getInventoryById,
  getFacilityInventoryList,
  postRequestInventory,
  patchAddFacilityInventory,
  deleteFacilityInventory,
  postInventoryNotes,
  getInventoryNotesGroupedByIds,
  postBulkTransfer,
} = {
  postInventoryNotes: (payload) => {
    return {
      type: "INVENTORY/POST_INVENTORY_NOTES",
      payload,
    };
  },
  getInventoryNotesGroupedByIds: (payload) => {
    return {
      type: "INVENTORY/GET_GROUPED_NOTES",
      payload,
    };
  },
  postBulkTransfer: (payload) => {
    return {
      type: "INVENTORY/POST_BULK_TRANSFER",
      payload,
    };
  },
  getInventoryById: (payload) => {
    const actionType = "INVENTORY/GET_INVENTORY_BY_ID";
    return {
      type: actionType,
      payload,
    };
  },
  getFacilityInventoryList: (payload) => {
    return {
      type: "INVENTORY/GET_INVENTORY_FACILITY_LIST",
      payload,
    };
  },
  postRequestInventory: (payload) => {
    return {
      type: "INVENTORY/POST_REQUEST_INVENTORY",
      payload,
    };
  },
  patchAddFacilityInventory: (payload) => {
    return {
      type: "INVENTORY/PATCH_FACILITY_INVENTORY",
      payload,
    };
  },
  deleteFacilityInventory: (payload) => {
    return {
      type: "INVENTORY/DELETE_FACILITY_INVENTORY",
      payload,
    };
  },
};

// GET INVENTORY DATA ASYNC
function* getInventoryByIdAsync(action) {
  // const { apiPayload, id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield InventoryService.getInventoryById(action?.payload);
    const { status } = response;
    if (status) {
      yield put(setInventoryData(response?.data));
    } else {
      console.error("No data returned from API");
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setInventoryData({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getFacilityInventoryListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield InventoryService.getFacilityInventoryList(
      action?.payload
    );

    const { status, data } = response;
    if (status) {
      yield put(getInventoriesListData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(getInventoriesListData({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* postRequestInventoryAsync(action) {
  try {
    yield put(showLoader());
    const response = yield InventoryService.postRequestInventory(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseRequestInventoryDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseRequestInventoryDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchAddFacilityInventoryDataAsync(action) {
  const { id, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield InventoryService.patchFacilityInventoryData(
      id,
      payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log("patch data", data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseRequestInventoryDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseRequestInventoryDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* deleteFacilityInventoryAsync(action) {
  const { id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield InventoryService.deleteFacilityInventory(id);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseDeleteInventoryDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseDeleteInventoryDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* postInventoryNotesAsync(action) {
  const { id, notes } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield InventoryService.postInventoryNotes(id, notes);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddNotesDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddNotesDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getInventoryNotesGroupedByIdsAsync(action) {
  const { ids } = action?.payload;
  try {
    yield put(showLoader());
    const response =
      yield InventoryService.getInventoryNotesGroupedByIds(ids);
    const { status } = response;
    if (status) {
      yield put(setGroupedNotesData(response?.data?.data || []));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setGroupedNotesData([]));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* postBulkTransferAsync(action) {
  try {
    yield put(showLoader());
    const response = yield InventoryService.postBulkTransfer(action?.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseSendBulkDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseSendBulkDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([
    takeLatest(getInventoryById().type, getInventoryByIdAsync),
    takeLatest(getFacilityInventoryList().type, getFacilityInventoryListAsync),
    takeLatest(postRequestInventory().type, postRequestInventoryAsync),
    takeLatest(
      patchAddFacilityInventory().type,
      patchAddFacilityInventoryDataAsync
    ),
    takeLatest(
      deleteFacilityInventory().type,
      deleteFacilityInventoryAsync
    ),
    takeLatest(postInventoryNotes().type, postInventoryNotesAsync),
    takeLatest(
      getInventoryNotesGroupedByIds().type,
      getInventoryNotesGroupedByIdsAsync
    ),
    takeLatest(postBulkTransfer().type, postBulkTransferAsync),
  ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
